
import Api from '@/utils/api';
import dayjs from 'dayjs';
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'

export default {
data() {
return {
couponType: null,
couponTypeCollected: 0,
scrollH: "300px",
listIndex: "-1",
isMoreList: false,
loadText: '正在加载',
btnLabel: '立即领取',
code: ''
}
},
components: {
Scroller,
XInput,
Group,
XButton,
Cell
},
computed: {
invalidCoupon() {
if (this.couponType.stock < 1) {
return true
} else if (this.couponTypeCollected >= this.couponType.collectLimit) {
return true
} else if (dayjs().isAfter(dayjs(this.couponType.expirationDate).endOf('day'))) {
return true
} else {
return false
}
},
couponBtnText() {
if (this.couponType.stock < 1) {
return '已领完'
} else if (this.couponTypeCollected >= this.couponType.collectLimit) {
return '已领取'
} else if (dayjs().isAfter(dayjs(this.couponType.expirationDate).endOf('day'))) {
return '已过期'
} else {
return '立即领取'
}
}
},
mounted() {
if (!this.$store.state.userInfo.mobileNumber) {
this.$router.push({
name: 'bindMobileNumber',
params: {
ref: 'coupon'
}
})
this.$vux.toast.text('领取兑换码需要先绑定你的手机号')
}
this.getCouponType()
this.getCouponTypeCollectedNumber()
},
methods: {
async getCouponType(){
try {
const resp = await Api.getCouponType({
id: this.$route.params.id
})
if (resp && resp.data) {
this.couponType = resp.data
} else {
throw Error()
}
} catch (e) {
this.$vux.alert.show({
title: '失败',
content: '无效的优惠券'
})

}
},
async getCouponTypeCollectedNumber(){
try {
const resp = await Api.getCouponTypeCollectedNumber({
id: this.$route.params.id
})
if (resp && resp.data) {
this.couponTypeCollected = resp.data
} else {
throw Error()
}
} catch (e) {

}
},
toDetail(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
});
},
onScrollBtm() {
if(this.isMoreList){
this.isMoreList = false
this.pagination.page ++
}
},
addCoupon() {
if(this.couponTypeCollected >= this.couponType.collectLimit){
this.$vux.toast.text('超过每人领取上限')
return
}
const that = this
Api.collectCoupon({
id: this.$route.params.id
})
.then(res => {
this.couponTypeCollected++
this.couponType.stock--




this.$vux.confirm.show({
title: '领取成功',
content: '获得['+this.couponType.name+']优惠券一张，立即查看',
onConfirm () {
that.$router.push({
name: 'couponDetail',
params: {
id: res.data._id
}
});
}
})
})
.catch(e => {
if(e && e.response && e.response.data) {
this.$vux.toast.text(e.response.data.message)
return
} else {
this.$vux.alert.show({
title: '失败',
content: '兑换码不可用'
})
}
})
},
addCart(item_id, sku_id, className, url) {
let imgBox = document.querySelector(`.${className}`);
let relative = imgBox.getBoundingClientRect();

this.$store.commit('updateClassifyAnimate', {
x: relative.left,
y: relative.top,
headPic: url,
item_id: item_id,
sku_id: sku_id,
random: Math.random() * 10000
});

},
}
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/addCoupon/collectCoupon.vue